import { z } from "zod";

const ClientEnvSchema = z.object({
    BASE_URL: z.string(),
    BLOB_BASE_URL: z.string(),
    CDN_BASE_URL: z.string(),    
    RECAPTCHA_SITE_KEY: z.string(),
});

const parsed = ClientEnvSchema.pick({
    BASE_URL: true,
    BLOB_BASE_URL: true,
    CDN_BASE_URL: true,
    RECAPTCHA_SITE_KEY: true,
}).safeParse({
    BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    BLOB_BASE_URL: process.env.NEXT_PUBLIC_BLOB_BASE_URL,
    CDN_BASE_URL: process.env.NEXT_PUBLIC_CDN_BASE_URL,
    RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
});

if (!parsed.success) {
    console.error(z.formatError(parsed.error));
    throw new Error("Invalid client env for Next");
}

export const clientEnv = {
    BASE_URL: parsed.data.BASE_URL,
    BLOB_BASE_URL: parsed.data.BLOB_BASE_URL,
    CDN_BASE_URL: parsed.data.CDN_BASE_URL,
    RECAPTCHA_SITE_KEY: parsed.data.RECAPTCHA_SITE_KEY,
} as const;